/**
 * account API 모듈
 * REQ-LOCALE-FE-005: PATCH /accounts/me/locale
 * REQ-LOCALE-FE-012: cancel-and-replace (AbortController)
 * REQ-LOCALE-FE-014: logout 시 in-flight PATCH abort
 *
 * F-26 가정: axios >= 0.22.0 (signal 옵션 지원) — package.json axios ^1.3.6 확인
 * SPEC: SPEC-CHINA-ADMIN-LOCALE-CORE-001
 */

import chinaInapi from '@/apis/chinaInapi';

// in-flight PATCH 요청 AbortController (모듈 스코프)
// REQ-LOCALE-FE-012: cancel-and-replace 패턴
let inflightController = null;

/**
 * PATCH /accounts/me/locale — locale 영속 저장
 * cancel-and-replace: 기존 요청이 있으면 abort 후 새 요청 발행
 * @param {string} locale - 'ko' | 'zh'
 * @returns {Promise<{locale: string}>}
 */
export async function patchAccountLocale(locale) {
  // 기존 in-flight 요청 abort (cancel-and-replace)
  if (inflightController) {
    inflightController.abort();
  }
  inflightController = new AbortController();

  try {
    const response = await chinaInapi.patch('/accounts/me/locale', { locale }, {
      signal: inflightController.signal,
    });
    return response.data;
  } finally {
    // 완료(성공/실패) 후 컨트롤러 해제
    inflightController = null;
  }
}

/**
 * in-flight PATCH 요청 abort
 * REQ-LOCALE-FE-014: logout 시 호출
 */
export function abortLocalePatch() {
  if (inflightController) {
    inflightController.abort();
    inflightController = null;
  }
}
